export class CompanyAdminModel {
    public companyID: number;
    public companyMasterHashId: string;
    public companyName: string;
    public personHashID: string;
    public userName: string;
    public firstName: string;
    public lastName: string;
    public isActive: boolean;
    public companyAdminHashId: string;
    public isChecked: boolean;
    public isUserCompanyAdmin:boolean;

    constructor() {
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/company-admin/models/companyAdmin.model.ts